import { useTranslation } from "react-i18next";
import { Settings, Users, Target, Zap, Shield } from "lucide-react";

const features = [
  {
    icon: Settings,
    key: "endtoend",
    color: "text-textBlue",
  },
  {
    icon: Users,
    key: "expertise",
    color: "text-secondaryOrange",
  },
  {
    icon: Target,
    key: "customer",
    color: "text-primaryBlue",
  },
  {
    icon: Zap,
    key: "innovation",
    color: "text-bgYellow",
  },
  {
    icon: Shield,
    key: "security",
    color: "text-textBlueDark",
  },
];

const WhyChooseUs = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-white py-16 px-6 sm:px-4 md:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-textBlue text-white text-md px-6 py-2 rounded-full mb-4">
            {t("why.label")}
          </span>
          <h2 className="text-4xl md:text-3xl sm:text-2xl font-bold text-gray-800">
            {t("why.title")}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-blueLight p-6 rounded-xl shadow transition-all duration-300 ease-in-out transform hover:shadow-lg hover:-translate-y-1 hover:bg-white group"
              >
                <div className="flex items-start space-x-4">
                  <div className="transition-transform duration-300 group-hover:scale-110">
                    <Icon className={`w-12 h-12 ${feature.color}`} />
                  </div>
                  <div>
                    <h3 className="text-xl sm:text-md font-semibold text-textBlueDark transition-colors duration-300 group-hover:text-textBlue mb-2">
                      {t(`why.items.${feature.key}.title`)}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      {t(`why.items.${feature.key}.description`)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
